import axios from '@/api/axios';
import {gql} from '@/api/utils';

export default {
  async fetchRegistrationScreenContext(cityId) {
    try {
      const query = gql`
        query registrationScreenContextQuery($cityId: ID!) {
          registrationScreenContextQuery(cityId: $cityId) {
            termsOfServiceAndPrivacyPolicyOptInCopy
            termsOfServiceAndPrivacyPolicyOptInCopyTooltip
            marketingCommunicationOptInCopy
            nationalPetRecordSearchOptInCopy
            beforeFormAlert {
              text
              color
              backgroundColor
            }
            noticeOfCollectionConsentContext {
              title
              body
              checkboxLabel
            }
            lostPetProgramOptInCopy
          }
        }
      `;

      const { registrationScreenContextQuery: screenContext } = await axios.post(`/`, { query, variables: { cityId } });

      return screenContext;
    } catch (error) {
      throw new Error(error?.message?.[0]?.message || error?.message || 'There was an unexpected error.');
    }
  },
};
